import { inject, singleton } from "tsyringe";
import { AdsContext } from "./ads-context";

@singleton()
export class ServiceBaseUrl {
  constructor(@inject(AdsContext) private readonly adsContext: AdsContext) {}

  get() {
    const env = this.adsContext.get()?.env;

    return env === "dev"
      ? "https://services.fandom-dev." +
          (location.hostname.match(/(?!\.)(pl|us)$/) || ["us"])[0] +
          "/"
      : "https://services.fandom.com/";
  }
}
